import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import FloatingButtonWrapper from "./FloatingButton.style";
import RestrictedComponent from "../util/RestrictedComponent";
import ButtonAnimationWrapper from "../animations/ButtonAnimationWrapper";
import { useSelector } from "react-redux";
const FloatingButton = (props) => {
  const {
    saveLoading,
    disabled,
    resource,
    action,
    show,
    saveText,
    onSubmit,
  } = props;
  const direction = useSelector(
    (state) => state.user.currentAppLocale.direction
  );

  return (
    <FloatingButtonWrapper direction={direction}>
      <RestrictedComponent resource={resource} action={action} comp={null}>
        <div style={{ display: "flex" }}>
          <ButtonAnimationWrapper show={show}>
            <Button
              className="floatingBtn"
              loading={saveLoading}
              disabled={disabled}
              onClick={onSubmit}
              htmlType="submit"
              type="primary"
              icon={<CheckOutlined />}
              size={"large"}
            >
              {" " + saveText}
            </Button>
          </ButtonAnimationWrapper>
        </div>
      </RestrictedComponent>
    </FloatingButtonWrapper>
  );
};

FloatingButton.propTypes = {
  saveLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  resource: PropTypes.string,
  action: PropTypes.string,
  show: PropTypes.bool,
  saveText: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default FloatingButton;
